import axios from "./axios";
import { ApiResponse } from "../types/express-data.type";
import {
  ExpenseCategoryNameList,
  MonthEstimateAnswer,
  MonthlyExpenseMonth,
  MonthlyExpenseSaveRequest,
} from "../types/monthly-expense.type";

const EXPENSE_CATEGORIES_PATH = "/expense-categories";
const MONTHLY_EXPENSES_PATH = "/monthly-expenses";

/** A refused write (a closed month, a future month) is the server's Thai message in the toast. */
const WRITE_META = { suppressForbiddenRedirect: true };

const monthPath = (yearMonth: string) =>
  `${MONTHLY_EXPENSES_PATH}/${encodeURIComponent(yearMonth)}`;

/** Every active category (daily and monthly) — S4 names its columns from both. */
export const getExpenseCategoryNames = () =>
  axios.get<ApiResponse<ExpenseCategoryNameList>>(EXPENSE_CATEGORIES_PATH);

/** S5: the estimate of `month`. A branch role gets its own branch; head office names one. */
export const getMonthlyExpenseEstimate = (month: string, branchCode?: string) =>
  axios.get<ApiResponse<MonthEstimateAnswer>>(`${MONTHLY_EXPENSES_PATH}/estimate`, {
    params: { month, branch_code: branchCode },
  });

/** S4: every van branch's month. */
export const getMonthlyExpenseMonth = (yearMonth: string) =>
  axios.get<ApiResponse<MonthlyExpenseMonth>>(monthPath(yearMonth));

/** บันทึกร่าง — answers the whole month. */
export const saveMonthlyExpenseDraft = (yearMonth: string, body: MonthlyExpenseSaveRequest) =>
  axios.put<ApiResponse<MonthlyExpenseMonth>>(monthPath(yearMonth), body, { meta: WRITE_META });

/** ส่งและปิดเดือน — one-way; answers the closed month. */
export const closeMonthlyExpenseMonth = (yearMonth: string) =>
  axios.post<ApiResponse<MonthlyExpenseMonth>>(`${monthPath(yearMonth)}/close`, null, {
    meta: WRITE_META,
  });
